import store from 'store';
import Form from 'components/form/Form';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import { completeAddToCart, sendProductForm, setAddToCartLabel, startAddToCartLoading } from 'helpers/addToCartButton';
import mqStore from 'store/mqStore';
import { frameToMs } from 'helpers/easings';
import { forceArray } from 'navigation/component/Component';
import { upperFirst } from 'lodash-es';
import Product from './Product';
import ProductDetails from './partials/ProductDetails';
import ProductInfos from './partials/ProductInfos';
import ProductSizeSelector from './partials/ProductSizeSelector';
class SimpleProduct extends Product {
    static pageName = 'Product';
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            form: ['.form.product__top', Form],
            details: ['.simple-product-details', ProductDetails],
            infos: ['.product-infos', ProductInfos],
            sizeSelector: ['.size-selector', ProductSizeSelector]
        };
    }
    pageName() {
        return 'Product';
    }
    initialized() {
        super.initialized();
        this.modules.form.quickValid();
        if (this.modules.sizeSelector)
            this.updateSizeSelectorConfirmLabel('article');
    }
    bindEvents(add) {
        super.bindEvents(add);
        const emitterMethod = bindEmitterMethod(add);
        const method = bindMethod(add);
        this?.el[method]?.('show-size', this.onSizeGuideBackwards);
        if (this.refs.toggleSizeSelector)
            this.refs.toggleSizeSelector.forEach(toggle => toggle[method]('click', this.onToggleSizeSelector));
        this.modules.form[emitterMethod]('submitted', this.onFormSubmitted);
        this.refs.addToCart?.forEach((el) => el[method]('click', this.onAddToCart));
        if (this.refs.addToCartSizeSelector)
            this.refs.addToCartSizeSelector[method]('click', this.onAddToCartSizeSelector);
        if (this.modules.sizeSelector) {
            this.modules.sizeSelector[emitterMethod]('change', this.onSizeChange);
            this.modules.sizeSelector[emitterMethod]('tab:change', this.onTabChange);
        }
        if (this.modules.bar)
            this.modules.bar[emitterMethod]('add-to-cart', this.onAddToCart);
        if (this.refs.notifyMe)
            forceArray(this.refs.notifyMe).forEach(notifyMe => notifyMe[method]('click', this.onNotifyMe));
        if (this.refs.preorder)
            forceArray(this.refs.preorder).forEach(preorder => preorder[method]('click', this.onPreorder));
        if (this.modules.infos)
            this.modules.infos[emitterMethod]('open:info', () => this.resize());
    }
    onFormSubmitted = (e) => {
        this.modules.form.setSubmitted(false);
    };
    onSizeGuideBackwards = () => {
        setTimeout(() => {
            store.drawer.set('size-selector');
        }, frameToMs(25));
    };
    onNotifyMe = (e) => {
        e.preventDefault();
        store.drawer.set('size-selector');
    };
    onSizeChange = (e) => {
        this.updateSizeSelectorConfirmLabel('article');
        this.modules.details.updateSizes(e);
        if (this.refs.socloz)
            this.refs.socloz.forEach(link => link.setAttribute('data-socloz-product-attributes-clothes_size', e.label));
    };
    updateSizeSelectorConfirmLabel = (priorityField) => {
        const btn = this.refs.addToCartSizeSelector;
        if (!btn)
            return;
        const formData = this.modules.form.getFormValues();
        setAddToCartLabel(btn, formData[priorityField] === undefined ? btn.dataset[`invalid${upperFirst(priorityField)}`] : btn.dataset.text);
    };
    onAddToCart = async (e) => {
        this.modules.form.setSubmitted(false);
        const valid = await this.modules.form.quickValid();
        if (!valid) {
            if (store.drawer.get() !== 'size-selector')
                store.drawer.set('size-selector');
            return;
        }
        const target = e.currentTarget;
        const btns = [...this.refs.addToCart];
        if (this.refs.addToCartSizeSelector)
            btns.push(this.refs.addToCartSizeSelector);
        await startAddToCartLoading(btns);
        sendProductForm({
            form: this.modules.form,
            submitter: target,
            callback: ({ xhr, data }) => {
                completeAddToCart(btns, data.error !== null);
                setTimeout(() => {
                    store.drawer.set(null);
                    if (mqStore.tabletPortrait.get())
                        this.modules.sizeSelector.reset();
                }, 500);
            }
        });
    };
    onPreorder = async (e) => {
        const valid = await this.modules.form.quickValid();
        if (!valid) {
            if (store.drawer.get() !== 'size-selector')
                store.drawer.set('size-selector');
        }
    };
    onAddToCartSizeSelector = async (e) => {
        const valid = await this.modules.form.quickValid();
        if (valid)
            this.onAddToCart(e);
    };
    onToggleSizeSelector = (e) => {
        if (e.currentTarget.dataset.oneSize)
            return;
        store.drawer.set('size-selector');
    };
    onTabChange = (index) => {
        this.updateSizeSelectorConfirmLabel(index === 0 ? 'article' : 'article_2');
    };
    getTabletPortraitDetailsHeight() {
        return this.modules.details.el.offsetHeight + this.modules.infos.el.offsetHeight;
    }
    resize() {
        super.resize();
        this.setToggleSizeSelectorPadding();
    }
    setToggleSizeSelectorPadding() {
        if (!this.refs.toggleColorSelector) {
            forceArray(this.refs.toggleSizeSelector).forEach((toggle) => {
                if (toggle)
                    toggle.style.paddingLeft = 0 + 'px';
            });
        }
    }
}
export default SimpleProduct;
